export default () => {
  $(".footer-banners.row.banner-wrapper").insertAfter(
    ".benefitBanner.position--benefitHomepage"
  );
  $(".content-wrapper.homepage-box.middle-banners-wrapper").insertBefore(
    ".content-wrapper.homepage-box.welcome-wrapper"
  );

  $(".benefitBanner.position--benefitHomepage").insertAfter(
    ".content-wrapper.homepage-box.welcome-wrapper"
  );
};
